import { Component, OnInit, OnDestroy, Renderer2, Inject, AfterViewInit, DOCUMENT } from '@angular/core';
import { Router, NavigationEnd, Event as NavigationEvent } from '@angular/router';
import { Subscription } from 'rxjs';

import { AuthService } from './auth/auth.service';
import { Constant } from './constant';
import { CommonUtil } from './util/common-util';
import { Meta } from '@angular/platform-browser';
import { Auth } from '@aws-amplify/auth';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  public calinTellNo = Constant.calinTellNo;
  public calinWorkTime = Constant.calinWorkTime;
  public calinSupportMail = Constant.calinSupportMail;
  lp = false;
  menuDisabled = false;
  public newsDate = '';
  public readonly Constant = Constant;
  public currentPage = ''
  // チャットbotのウィジェット表示可否
  public showChatWidget = false;
  private isLoggedIn = false;
  private isChatEnabledPage = false;
  private loggedInSubscription?: Subscription;

  constructor(
    public auth: AuthService,
    private commonUtil: CommonUtil,
    private router: Router,
    private meta: Meta,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    // 単独ページ判断（LP、エラー）
    this.router.events.forEach((event: NavigationEvent) => {
      // NavigationEnd
      if (event instanceof NavigationEnd) {
        this.currentPage = event.urlAfterRedirects
        if (
          event.urlAfterRedirects === '/' ||
          event.urlAfterRedirects === '/error' ||
          event.urlAfterRedirects === '/maintenance' ||
          event.urlAfterRedirects.indexOf(Constant.rtLpNewgrad) >= 0 ||
          event.urlAfterRedirects.indexOf(Constant.rtLpCareer) >= 0 ||
          event.urlAfterRedirects === '/faq' ||
          event.urlAfterRedirects.indexOf(Constant.rtCase) >= 0 ||
          event.urlAfterRedirects.indexOf(Constant.rtRequest) >= 0 ||
          event.urlAfterRedirects === '/' + Constant.rtDownload ||
          event.urlAfterRedirects.indexOf(Constant.rtMsgFile) >= 0 ||
          event.urlAfterRedirects.indexOf(Constant.rtTmpFile) >= 0 ||
          event.urlAfterRedirects.indexOf(Constant.rtAttachment) >= 0 ||
          event.urlAfterRedirects.indexOf('/detail') >= 0 ||
          event.url.indexOf('#') > -1 ||
          event.url.indexOf('/?') > -1
        ) {
          this.lp = true;
        } else {
          this.lp = false;
        }

        // サイドメニュー非表示
        // 一斉メッセージ関連（レポートは除く）、タレントカルテ、質問管理、コンテンツカテゴリー、ログイン、パスワード変更
        if ((event.urlAfterRedirects.indexOf('/message_') >= 0 && event.urlAfterRedirects.indexOf('/message_report') < 0) ||
            event.urlAfterRedirects.indexOf('/detail') >= 0 ||
            event.urlAfterRedirects.indexOf('/question') >= 0 ||
            event.urlAfterRedirects.indexOf(Constant.rtPrContentsCategory) >= 0 ||
            event.urlAfterRedirects.indexOf('/login') >= 0 ||
            event.urlAfterRedirects.indexOf('/password_change') >= 0) {
          this.menuDisabled = true;
        } else {
          this.menuDisabled = false;
        }

        // noindex
        // TODO: LP作成時にindexするページを確認して、必要に応じて修正する
        // if ( environment.production && (
        //   event.urlAfterRedirects === '/' ||
        //   event.urlAfterRedirects.indexOf(Constant.rtLpNewgrad) >= 0 ||
        //   event.urlAfterRedirects.indexOf(Constant.rtLpCareer) >= 0 ||
        //   event.urlAfterRedirects === '/request/whitepaper' ||
        //   event.urlAfterRedirects === '/request/account' ||
        //   event.urlAfterRedirects === '/faq' ||
        //   event.urlAfterRedirects.indexOf(Constant.rtCase) >= 0)
        // ) {
        //   this.meta.updateTag({ name: 'robots', content: 'index,follow' });
        // } else {
        //   this.meta.updateTag({ name: 'robots', content: 'noindex,nofollow' });
        // }

        // LP、ログイン画面以外の場合、アクセス日時を登録
        if (!this.lp && event.urlAfterRedirects.indexOf('/login/') === -1) {
          this.putLastAccessDate();
        }

        if(localStorage.getItem('forceLogout') === 'true'){
          this.commonUtil.showReloadDialog(this.auth);
        }

        // チャットbot非表示（ログイン、サインアップ、パスワード変更、権限エラー）
        this.isChatEnabledPage = !(
          event.urlAfterRedirects.indexOf('/login') >= 0 ||
          event.urlAfterRedirects.indexOf('/signup') >= 0 ||
          event.urlAfterRedirects.indexOf('/password_change') >= 0 ||
          event.urlAfterRedirects.indexOf('/access-denied') >= 0
        );
        this.refreshChatWidget();

        //　フォーカスを外す
        const elm = <HTMLElement>document.activeElement;
        elm.blur();
      }
    });

    // ログイン状態に追従してチャットbotの表示を切り替える
    this.loggedInSubscription = this.auth.loggedIn.subscribe(loggedIn => {
      this.isLoggedIn = loggedIn;
      this.refreshChatWidget();
    });

    // アナリティクストラッキングID
    // TODO: アナリティクストラッキングIDを設定する
    // gtag('js', new Date());
    // gtag('config', environment.AnalyticsTrackingId);
  }

  ngOnDestroy(): void {
    this.loggedInSubscription?.unsubscribe();
  }

  ngAfterViewInit(): void {
    // google font 読み込み
    const link = this.renderer.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
    this.renderer.appendChild(this.document.head, link);
  }

  isWidth100() {
    return this.currentPage.indexOf('/myevent-detail/') >= 0
    || this.currentPage.indexOf('/union-consultation/') >= 0;
  }

  // チャットbotはログイン済み・権限あり（未承認でない）・対象画面のときだけ表示する
  private refreshChatWidget() {
    this.showChatWidget = this.isLoggedIn && this.isChatEnabledPage && this.auth.hasAuth(3);
  }

  // 最終アクセス日時の記録
  private putLastAccessDate() {
    Auth.currentSession().then(session => {
      const apiPath = '/access/lastdate';
      const options = this.auth.createApiHeader(session);
      this.commonUtil
        .apiPut(apiPath, options)
        .then(res => {})
        .catch(err => {
          this.commonUtil.debug().log(err);
        });
    });
  }

}
